import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminPopup.css";
import AdminPopupImg from "../AdminPopupImg/AdminPopupImg";
import api from "../../utils/Api";

import Colors from "../../images/adminColors.svg";
import Razm from "../../images/adminRazm.svg";
import Star from "../../images/adminStar.svg";
import Arrow from "../../images/arrow.svg";
import NewImg from "../../images/adminNewImg.svg";

import AdminClose from "../../images/adminClose.svg";

function AdminPopup(props) {
  const [formValues, setFormValues] = useState({
    ArcInput: "",
    ColorInput: "",
    RazmInput: "",
    DiffInput: "",
    image: "",
    firstImage: "",
    TwoImage: "",
    image: "",
  });

  useEffect(() => {
    console.log(props.cardPatchInfo);
    if (props.cardPatchInfo) {
      if (props.cardPatchInfo.article) {
        setFormValues((prevFormValues) => ({
          ...prevFormValues,
          ArcInput: props.cardPatchInfo.article,
        }));
      }
      if (props.cardPatchInfo.colors) {
        setFormValues((prevFormValues) => ({
          ...prevFormValues,
          ColorInput: props.cardPatchInfo.colors,
        }));
      }
      if (props.cardPatchInfo.size) {
        setFormValues((prevFormValues) => ({
          ...prevFormValues,
          RazmInput: props.cardPatchInfo.size,
        }));
      }
      if (props.cardPatchInfo.difficulty) {
        setFormValues((prevFormValues) => ({
          ...prevFormValues,
          DiffInput: props.cardPatchInfo.difficulty,
        }));
      }
    }
  }, [props.cardPatchInfo]);

  const [adminImg, setAdminImg] = useState(false);
  const [arcErr, setArcErr] = useState(false);
  function handleChange(e) {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  }

  function handleImageUpload(e) {
    const file = e.target.files[0]; // Получаем файл
    if (file) {
      setFormValues({
        ...formValues,
        image: file, // Сохраняем файл
      });
    }
  }

  //Slider
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState("right");

  const slides = [
    {
      type: "input",
      content: (
        <label className="adminpopup__popup__img__cont__label">
          <div className="adminpopup__popup__img__cont__label__info">
            <img
              src={NewImg}
              alt="icon"
              className="adminpopup__popup__img__cont__label__info__img"
            />
            <p className="adminpopup__popup__img__cont__label__info__title">
              Загрузить новое изображение
            </p>
            {formValues.image && (
              <img
                src={URL.createObjectURL(formValues.image)}
                alt="Выбранное"
                className="adminpopup__popup__img__cont__label__info__imgv"
              />
            )}

            <input
              type="file"
              className="adminpopup__popup__img__cont__label__info__input"
              onChange={handleImageUpload}
            />
          </div>
        </label>
      ),
    },
    {
      type: "button",
      content: (
        <label className="adminpopup__popup__img__cont__label">
          <button
            onClick={() => {
              setAdminImg(true);
            }}
            className="adminpopup__popup__img__cont__label__info"
          >
            <img
              src={NewImg}
              alt="icon"
              className="adminpopup__popup__img__cont__label__info__img"
            />
            <p className="adminpopup__popup__img__cont__label__info__title">
              Загрузить новое двойное изображение
            </p>
          </button>
        </label>
      ),
    },
  ];

  const handleNext = () => {
    setDirection("right");
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  const handlePrev = () => {
    setDirection("left");
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + slides.length) % slides.length
    );
  };

  function handleSubmite(e) {
    if (
      props.cards.some((card) => card.article === formValues.ArcInput) &&
      (!props.cardPatchInfo ||
        props.cardPatchInfo.article !== formValues.ArcInput)
    ) {
      setArcErr(true);
    } else {
      if (props.cardPatch) {
        api
          .patchCard(
            {
              article: formValues.ArcInput,
              size: formValues.RazmInput,
              difficulty: formValues.DiffInput,
              colors: formValues.ColorInput,
              image: formValues.image,
              firstcolors: formValues.firstImage,
              twocolors: formValues.TwoImage,
            },
            props.cardPatchInfo.id
          )
          .then((data) => {
            if (data.message === "Карточка успешно обновлена.") {
              props.setOpenPopup(false);
              props.getCards();
              props.setCardPatch(false);
              props.setCardPatchInfo(null);
            }
          });
      } else {
        api
          .addCard({
            article: formValues.ArcInput,
            size: formValues.RazmInput,
            difficulty: formValues.DiffInput,
            colors: formValues.ColorInput,
            image: formValues.image,
            firstcolors: formValues.firstImage,
            twocolors: formValues.TwoImage,
          })
          .then((data) => {
            if (data.message === "Карточка успешно создана.") {
              props.setOpenPopup(false);
              props.getCards();
            }
          });
      }
    }
  }

  return (
    <div className="AdminPopup">
      <div className="adminpopup__popup">
        <img
          onClick={() => {
            props.setOpenPopup(false);
            props.setCardPatchInfo(null);
            props.setCardPatch(false);
          }}
          alt="close"
          src={AdminClose}
          className="adminpopup__popup__close"
        />
        <div className="adminpopup__popup__img">
          <button onClick={handlePrev} className="adminpopup__popup__img__left">
            <img alt="icon" src={Arrow} />
          </button>
          <div
            className={`adminpopup__popup__img__cont   slider__content--${direction}`}
          >
            {slides.map((slide, index) => (
              <div
                key={index}
                className={`slider__slide ${
                  index === currentIndex ? "slider__slide--active" : ""
                }`}
              >
                {slide.content}
              </div>
            ))}
          </div>
          <button
            onClick={handleNext}
            className="adminpopup__popup__img__right"
          >
            <img alt="icon" src={Arrow} />
          </button>
        </div>
        <div className="adminpopup__popup__info">
          <input
            className="adminpopup__popup__info__inputArc"
            placeholder="Введите артикул"
            type="text"
            value={formValues.ArcInput.toUpperCase()}
            onChange={handleChange}
            name="ArcInput"
          />
          <div className="adminpopup__popup__info__inputs">
            <img
              alt="icon"
              src={Colors}
              className="adminpopup__popup__info__inputs__img"
            />
            <p className="adminpopup__popup__info__inputs__title">Цветов:</p>
            <input
              className="adminpopup__popup__info__inputs__input"
              type="text"
              placeholder="Введите колличество цветов"
              value={formValues.ColorInput}
              onChange={handleChange}
              name="ColorInput"
            />
          </div>
          <div className="adminpopup__popup__info__inputs">
            <img
              alt="icon"
              src={Razm}
              className="adminpopup__popup__info__inputs__img"
            />
            <p className="adminpopup__popup__info__inputs__title">Размер:</p>
            <input
              className="adminpopup__popup__info__inputs__input"
              type="text"
              placeholder="Введите размер"
              value={formValues.RazmInput}
              onChange={handleChange}
              name="RazmInput"
            />
          </div>
          <div className="adminpopup__popup__info__inputs">
            <img
              alt="icon"
              src={Star}
              className="adminpopup__popup__info__inputs__img"
            />
            <p className="adminpopup__popup__info__inputs__title">Сложность:</p>
            <button
              type="button"
              onClick={() => {
                setFormValues({
                  ...formValues,
                  DiffInput: "easy",
                });
              }}
              className={`adminpopup__popup__info__inputs__btn ${
                formValues.DiffInput === "easy" && "btnGreen"
              }`}
            >
              Легкая
            </button>
            <button
              type="button"
              onClick={() => {
                setFormValues({
                  ...formValues,
                  DiffInput: "normal",
                });
              }}
              className={`adminpopup__popup__info__inputs__btn ${
                formValues.DiffInput === "normal" && "btnOrange"
              }`}
            >
              Средняя
            </button>
            <button
              type="button"
              onClick={() => {
                setFormValues({
                  ...formValues,
                  DiffInput: "hard",
                });
              }}
              className={`adminpopup__popup__info__inputs__btn ${
                formValues.DiffInput === "hard" && "btnRed"
              }`}
            >
              Сложная
            </button>
          </div>
          {arcErr && <p className="arcError">Артикул уже существует</p>}
          <div className="adminpopup__popup__info__btns">
            <button
              type="button"
              onClick={() => {
                handleSubmite();
              }}
              className="adminpopup__popup__info__btns__btn"
            >
              Принять изменения
            </button>
            <button
              onClick={() => {
                props.setOpenPopup(false);
                props.setCardPatchInfo(null);
                props.setCardPatch(false);
              }}
              type="button"
              className="adminpopup__popup__info__btns__btn"
            >
              Отменить изменения
            </button>
          </div>
        </div>
      </div>
      {adminImg && (
        <AdminPopupImg
          setAdminImg={setAdminImg}
          setFormValues={setFormValues}
          formValues={formValues}
        />
      )}
    </div>
  );
}

export default AdminPopup;
